module.exports = __webpack_public_path__ + "static/media/absenceNotif.5e9ff06b.svg";